import React from 'react';
import { useMainPerformanceTotalSales, useMainPerformanceSubscriptionRate } from '../../../hooks/useMainPerformanceKPIs';
import KPICard from '../../ui/KPICard';
import LoadingSpinner from '../../ui/LoadingSpinner';
import ErrorMessage from '../../ui/ErrorMessage';
import { KPIProps } from '../../../types/kpi';
import { formatNumber, formatPercentage } from '../../../utils/formatters';

const SubscriptionRateKPI: React.FC<KPIProps> = ({
  branchId = 0,
  timeRange = 'last6Months',
  onError,
  showLoading = true,
  compact = false,
  className = ''
}) => {
  const { data, isLoading, isError, error, refetch } = useMainPerformanceSubscriptionRate(branchId, timeRange);
  const { data: totalSalesData } = useMainPerformanceTotalSales(branchId, timeRange);

  // Handle error callback
  React.useEffect(() => {
    if (isError && error && onError) {
      onError(error as Error);
    }
  }, [isError, error, onError]);

  if (isLoading && showLoading) {
    return (
      <div className={`animate-enter animate-delay-3 ${className}`}>
        <div className="card-base card-padding">
          <div className="flex items-center justify-center h-32">
            <LoadingSpinner variant="minimal" size="md" />
          </div>
        </div>
      </div>
    );
  }

  if (isError && error) {
    return (
      <ErrorMessage 
        message="خطا در دریافت نرخ اشتراک‌گیری"
        onRetry={() => refetch()}
        className={className}
      />
    );
  }

  const subscriptionRate = data?.subscriptionRate || 0;
  const totalInvoices = totalSalesData?.totalInvoices || 0;

  return (
    <KPICard
      title="اشتراک‌گیری"
      value={formatPercentage(subscriptionRate)}
      subtitle={`تعداد سفارش: ${formatNumber(totalInvoices)}`}
      variant="success"
      accentStyle="corner"
      className={`animate-enter-up stagger-3 ${className}`}
      loading={isLoading && !showLoading}
    />
  );
};

export default SubscriptionRateKPI;